// NOTE: How should this be handled? Database table?
export const CURRENCY_USD = 'USD';
export const CURRENCY_USD_LOWERCASE = 'usd';

export const USD_UNIT_CONVERSION_FACTOR = 100;

// List of zero-decimal currencies
// https://stripe.com/docs/currencies#zero-decimal
export const ZERO_DECIMAL_CURRENCIES = [
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'JPY',
  'KMF',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'UGX',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
];
